module.exports = __webpack_public_path__ + "img/vivienda.3579419a.svg";